import * as mutationTypes from '@/store/mutation-types'

const personal = {
  namespaced: true,
  state: {
    isHideAssetsData: true, // 是否隐藏资产数据（默认：显示）
    isHideZeroBalance: false // 是否隐藏零余额币种（默认：不隐藏）
  },
  mutations: {
    [mutationTypes.SET_HIDE_ASSETS_DATA](state, boolean) {
      state.isHideAssetsData = boolean
    },
    [mutationTypes.SET_HIDE_ZERO_BALANCE](state, boolean) {
      state.isHideZeroBalance = boolean
    }
  }
}

export default personal
